import { Skeleton, Spin } from 'antd';
import { space } from '@/design/tokens.js';

export interface LoadingStateProps {
  /** `skeleton` for content you can predict the shape of; `spinner` otherwise. */
  variant?: 'skeleton' | 'spinner';
  rows?: number;
  label?: string;
}

/**
 * Shown while data is loading.
 *
 * Prefer the skeleton. A skeleton reserves the space the content will occupy,
 * so the page does not jump when it arrives — and a layout shift after a
 * spinner disappears is a real usability cost, not a cosmetic one. Use the
 * spinner only where the eventual shape is genuinely unknown.
 *
 * `aria-busy` and the visually-hidden label mean a screen-reader user is told
 * the page is working, rather than being read an empty region.
 */
export function LoadingState({
  variant = 'skeleton',
  rows = 3,
  label = 'Loading',
}: LoadingStateProps) {
  if (variant === 'spinner') {
    return (
      <div aria-busy="true" style={{ display: 'grid', placeItems: 'center', padding: space[16] }}>
        <Spin size="large" />
        <span className="orbit-visually-hidden">{label}</span>
      </div>
    );
  }

  return (
    <div aria-busy="true">
      <Skeleton active paragraph={{ rows }} title />
      <span className="orbit-visually-hidden">{label}</span>
    </div>
  );
}
